import { render, staticRenderFns } from "./WelfareCentreNature.vue?vue&type=template&id=43fd1401&scoped=true&"
import script from "./WelfareCentreNature.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreNature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd1401",
  null
  
)

export default component.exports